import { SearchBrowseParams } from '@aibees/elephant/types';
import { Maybe } from '@aibees/shared/definition';
import { INNER_SEPARATOR, ITEM_SEPARATOR } from './config';

export function buildDraft(
  params: Partial<SearchBrowseParams>,
  field: string,
  itemIndex: number,
  valueIndex: number,
  value: Maybe<string>
): Maybe<string> {
  const currentParams = params[field];

  if (!currentParams) {
    const newItemValues: (string | undefined)[] = [];
    newItemValues[valueIndex] = value;
    return newItemValues.join(INNER_SEPARATOR);
  }

  const items = currentParams.split(ITEM_SEPARATOR);
  const itemToUpdate = items[itemIndex] ?? INNER_SEPARATOR;
  const itemValues: (string | undefined)[] =
    itemToUpdate.split(INNER_SEPARATOR);

  itemValues[valueIndex] = value;

  items[itemIndex] = itemValues.join(INNER_SEPARATOR);

  const draft = items.join(ITEM_SEPARATOR);
  return draft && draft !== '' ? draft : undefined;
}

export function getItemsArray(
  params: Partial<SearchBrowseParams>,
  field: string
): string[] {
  const currentParams = params[field];
  return currentParams ? currentParams.split(ITEM_SEPARATOR) : [];
}

export function clearEmployeeByDepartmentItem(
  params: Partial<SearchBrowseParams>,
  field: string,
  index: number
): Maybe<string> {
  const currentParam = params[field];
  if (!currentParam) return;
  const items = currentParam.split(ITEM_SEPARATOR);
  if (!items[index]) return;

  const filteredItems = items.filter((_, i) => i !== index);

  if (filteredItems.length === 0) return undefined;

  return filteredItems.join(ITEM_SEPARATOR);
}

export function clearDepartmentValue(
  params: Partial<SearchBrowseParams>,
  field: string,
  valueToRemove: string
): Maybe<string> {
  const currentParam = params[field];
  if (!currentParam) return;
  const items = currentParam.split(ITEM_SEPARATOR);

  const updatedItems = items.map((item) => {
    if (item.includes(valueToRemove)) {
      return item.replace(valueToRemove, '');
    }
    return item;
  });

  return updatedItems.join(ITEM_SEPARATOR);
}
